import { Container, Flex, Tabs, Text } from "@chakra-ui/react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";

import TableList from "@/components/Tables/TableList";
import TableFields from "@/components/Tables/TableFields";

const tableManagementSearchSchema = z.object({
  page: z.number().catch(1),
});

export const Route = createFileRoute("/_layout/tableList")({
  component: TableManagement,
  validateSearch: (search) => tableManagementSearchSchema.parse(search),
});

function TableManagement() {
  const navigate = useNavigate({ from: Route.fullPath });
  const { page } = Route.useSearch();

  // 테이블 관리 하위 탭 상태 관리
  const [activeTableTab, setActiveTableTab] = useState("tables"); // 'tables' 또는 'tableFields'

  const handleTableRowClick = (tableId: string) => {
    navigate({ to: `/table/${tableId}` });
  };

  return (
    <Container maxW="full" px={4}>
      <Flex align="center" gap={2} py={4}>
        <Text fontSize="2xl" fontWeight="bold">
          테이블 관리
        </Text>
      </Flex>

      <Tabs.Root
        value={activeTableTab}
        onValueChange={(details) => setActiveTableTab(details.value)}
        variant="enclosed"
        style={{ marginTop: "16px" }}
      >
        <Tabs.List>
          <Tabs.Trigger value="tables">
            <Flex align="center" gap={2}>
              <Text>테이블 목록</Text>
            </Flex>
          </Tabs.Trigger>
          <Tabs.Trigger value="tableFields">
            <Flex align="center" gap={2}>
              <Text>테이블 필드</Text>
            </Flex>
          </Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value="tables">
          <TableList
            onTableRowClick={handleTableRowClick}
            currentPage={page}
            onPageChange={({ page: newPage }) =>
              navigate({
                search: (prev: Record<string, unknown>) => ({
                  ...prev,
                  page: newPage,
                }),
              })
            }
          />
        </Tabs.Content>

        <Tabs.Content value="tableFields">
          <TableFields />
        </Tabs.Content>
      </Tabs.Root>
    </Container>
  );
}
